import React, { useLayoutEffect } from "react";
import {
  CLUB_ACCENT,
  CLUB_CTA,
  CLUB_HEADLINE,
  CLUB_KICKER,
  CLUB_OFFER,
  CLUB_TERMS,
} from "config/bizHost";
import { useSignupForm } from "hooks/useSignupForm";
import TurnstileWidget, {
  TurnstileWidgetHandle,
} from "components/TurnstileWidget";
import LogoWinAZ from "assets/img-winaz/club/logo.webp";
import TypoWinAZ from "assets/img-winaz/club/typo.webp";
import BackgroundGirl from "assets/img-winaz/club/gai.webp";
import BackgroundMoney from "assets/img-winaz/club/money.webp";
import IconUser from "assets/img-winaz/signup-form/iconusser.webp";
import IconPassword from "assets/img-winaz/signup-form/iconpassword.webp";
import LabelWithdraw from "assets/img-winaz/29k-landing/lbelruttiensieutoc.webp";
import LabelSupport from "assets/img-winaz/29k-landing/lbelhotro247.webp";
import IconBlockchain from "assets/img-winaz/icon-baomat/icon-blockchain.webp";
import IconMd5 from "assets/img-winaz/icon-baomat/icon-md5.webp";
import IconGamingLabs from "assets/img-winaz/icon-baomat/icon-gaming-labs.webp";
import Certificate1 from "assets/img-winaz/club/cert-2046.webp";
import Certificate2 from "assets/img-winaz/club/cert-2047.webp";
import Certificate3 from "assets/img-winaz/club/cert-2048.webp";
import Certificate4 from "assets/img-winaz/club/cert-2049.webp";
import Certificate5 from "assets/img-winaz/club/cert-2050.webp";
import Certificate6 from "assets/img-winaz/club/cert-2051.webp";
import styles from "./styles.module.scss";

const CERTIFICATES = [
  Certificate1,
  Certificate2,
  Certificate3,
  Certificate4,
  Certificate5,
  Certificate6,
];

const ClubLanding: React.FunctionComponent = () => {
  const turnstileWidgetRef = React.useRef<TurnstileWidgetHandle>(null);
  const {
    username,
    password,
    apiError,
    usernameError,
    passwordError,
    isSubmitting,
    turnstileRequired,
    handleSubmit,
    handleUsernameChange,
    handlePasswordChange,
    handleTurnstileTokenChange,
  } = useSignupForm({
    requireConfirmPassword: false,
    formId: "club_signup",
    onTurnstileReset: () => turnstileWidgetRef.current?.reset(),
  });

  useLayoutEffect(() => {
    document.documentElement.lang = "vi";
    document.title = CLUB_OFFER;
    const form = document.getElementById("club-signup");
    const offer = document.getElementById("club-offer");
    if (form && offer && form.getBoundingClientRect().height > 0) {
      offer.hidden = true;
    }
  }, []);

  return (
    <main className={styles.page}>
      <div className={styles.scene} aria-hidden="true">
          <img
            className={styles.money}
            src={BackgroundMoney}
            alt=""
            width={440}
            height={324}
          />
          <img
            className={styles.girl}
            src={BackgroundGirl}
            alt=""
            width={430}
            height={766}
          />
      </div>
      <div className={styles.stage}>
        <img
          className={styles.logo}
          src={LogoWinAZ}
          alt="WinAZ"
          width={216}
          height={176}
        />
        <img className={styles.typo} src={TypoWinAZ} alt="" width={400} height={136} />
        <div className={styles.copy}>
          <p className={styles.kicker}>{CLUB_KICKER}</p>
          <h1 className={styles.offer}>
            {CLUB_HEADLINE.replace(CLUB_ACCENT, "").trim()}{" "}
            <span className={styles.multiplier}>{CLUB_ACCENT}</span>
          </h1>
          <p className={styles.terms}>{CLUB_TERMS}</p>
        </div>
        <form id="club-signup" className={styles.form} onSubmit={handleSubmit}>
          <label className={styles.field}>
            <img src={IconUser} alt="" width={52} height={60} />
            <input
              type="text"
              placeholder="Tên đăng nhập"
              value={username}
              onChange={handleUsernameChange}
              disabled={isSubmitting}
              aria-label="Tên đăng nhập"
            />
          </label>
          {usernameError ? (
            <div className={styles.error} role="alert">
              Vui lòng nhập tên đăng nhập
            </div>
          ) : null}
          <label className={styles.field}>
            <img src={IconPassword} alt="" width={51} height={69} />
            <input
              type="password"
              placeholder="Mật khẩu"
              value={password}
              onChange={handlePasswordChange}
              disabled={isSubmitting}
              aria-label="Mật khẩu"
            />
          </label>
          {passwordError ? (
            <div className={styles.error} role="alert">
              Vui lòng nhập mật khẩu
            </div>
          ) : null}
          {turnstileRequired ? (
            <TurnstileWidget
              ref={turnstileWidgetRef}
              onTokenChange={handleTurnstileTokenChange}
            />
          ) : null}
          {apiError ? (
            <div className={styles.error} role="alert">
              {apiError}
            </div>
          ) : null}
          <button
            className={styles.button}
            type="submit"
            disabled={isSubmitting}
            data-cta
          >
            {CLUB_CTA}
          </button>
        </form>
        <div className={styles.trust}>
          <div className={styles.serviceRow}>
            <img src={LabelWithdraw} alt="Rút tiền siêu tốc" />
            <img src={LabelSupport} alt="Hỗ trợ 24/7" />
          </div>
          <div className={styles.certificates}>
            {CERTIFICATES.map((src, index) => (
              <img
                key={src}
                src={src}
                alt={`Chứng nhận ${index + 1}`}
                width={168}
                height={72}
              />
            ))}
          </div>
          <div className={styles.certs}>
            <img src={IconBlockchain} alt="Blockchain" width={66} height={65} />
            <img src={IconMd5} alt="MD5" width={66} height={65} />
            <img
              src={IconGamingLabs}
              alt="Gaming Labs Certified"
              width={131}
              height={56}
            />
          </div>
          <p className={styles.trustLine}>Minh bạch hoàn toàn</p>
        </div>
      </div>
    </main>
  );
};

export default ClubLanding;
